/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useForm, FormProvider, yup, yupResolver } from '@gvlab/react-form';

import { Alert, Button } from '@gvlab/react-ui/components';

import { TextField } from '@gvlab/react-theme/mui';

import { forgotPassword, verify } from 'store/Auth/recoverSlice';

/**
 * Form Validation Schema
 */
const schema = yup.object().shape({
  email: yup.string().email('You must enter a valid email').required('You must enter an email'),
});

const defaultValues = {
  email: '',
};

const Form1 = ({ authCtx }) => {
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);

  const methods = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });
  const {
    register,
    getValues,
    reset,
    trigger,
    setError,
    formState: { isValid, dirtyFields, errors },
  } = methods;

  const onSubmit = async (model) => {
    try {
      dispatch(forgotPassword(model));
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <FormProvider {...methods}>
      <div className="mb-8 text-left">
        <p className="text-sm dark:text-gray-400 text-gray-400">
          Enter your email and we'll send you a OTP to reset your password.
        </p>
      </div>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        className="space-y-12 ng-untouched ng-pristine ng-valid"
      >
        <div className="space-y-4">
          <div>
            <TextField
              error={!!errors?.email}
              helperText={errors?.email?.message}
              label="Email address"
              margin="dense"
              fullWidth
              {...register('email')}
              className="w-full px-3 py-2 border rounded-md dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100"
            />
          </div>
        </div>
        <div className="space-y-2">
          <Button
            color="primary"
            disabled={!!dirtyFields || !isValid}
            progress={loading}
            size="large"
            variant="contained"
            type="submit"
            onClick={methods.handleSubmit(onSubmit)}
            className="w-full px-8 py-3 font-semibold rounded-md"
          >
            Submit
          </Button>
          <div className="flex justify-between mb-2 mt-4">
            <a rel="noopener noreferrer" href="/auth/login" className="hover:underline">
              Return to the Sign in
            </a>
            <a
              rel="noopener noreferrer"
              href="#"
              className="hover:underline"
              onClick={() => {
                dispatch(verify());
              }}
            >
              Verify OTP
            </a>
          </div>
        </div>
        {showAlert && (
          <Alert
            message={errors?.general?.message}
            onClose={() => {
              setShowAlert(false);
            }}
          />
        )}
      </form>
    </FormProvider>
  );
};

export default Form1;
